define('jackpotDom',['jquery', 'jackpots', 'translations', 'settings', 'util', 'rollNumber', 'transit'],
	function ($, Jackpot, T, settings, util, roller) {
		var $jackpots = [],
			$jackpotsSwitch = [],
			$winner,
			formatValue,
			togglingJackpots = [],
			staticJackpots = [],
			rollNumber = {},
			motdCallback,
			errorShow,
			object = {
				showingJackpotWinner: false,
				setFunctions: function (errorCb, updateCb, format) {
					if (!errorShow || !motdCallback || !formatValue) {
						errorShow = errorCb;
						motdCallback = updateCb;
						formatValue = format;
					}
				},
				init: function (target, gameNo) {
					$jackpots[gameNo] = target.jackpot; // every game has different jackpots
					$jackpotsSwitch[gameNo] = target.jackpotSwitch;
					$winner = target.jackpotWinner;

					if (settings.games.length === 1) {
						insertEmptyJackpot($jackpots[gameNo]);
					}

					if (!settings.local.promoVideoURL) {
						Jackpot.init(jackpotAdd, jackpotRemove, jackpotUpdate, errorShow, gameNo);
						return;
					}

					settings.local.staticJackpots.forEach(function (jackpot, i) {
						jackpotAddStatic({
							id: i,
							title: jackpot.title,
							prize: jackpot.prize
						}, gameNo);
					});
				},
				showJackpotWinner: function (winner, gameNo) {
					var congrats = T.translate('translate_jc'),
						message = T.translate('translate_jm');

					congrats = congrats.replace(/%w/, winner.winnerId);
					message = message.replace(/%n/, winner.name);
					object.showingJackpotWinner = true;
					$winner.addClass('active').find('div').html(congrats).next()
						.html(message + util.formatBid(winner.amount, gameNo));
					setTimeout(function () {
						motdCallback();
						object.showingJackpotWinner = false;
						$winner.removeClass('active');
					}, settings.local.jackpotWinDisplay);
				}
			};

		function generateJackpot(pot) {
			return $(`
				<div data-jackpot-id=${pot.id}>
					<div class="title"></div>
					<div class="content">
						<div class="current">
							<div class="number"></div>
						</div>
					</div>
				</div>
			`);
		}

		function jackpotAdd(jackpot, gameNo) {
			var pot = generateJackpot(jackpot);

			if ($jackpots[gameNo].hasClass('empty')) {
				$jackpots[gameNo].removeClass('empty');
			}
			$jackpots[gameNo].find('.pots').append(pot);

			if (Jackpot.jackpots[gameNo].length > 0 && !$jackpotsSwitch[gameNo].hasClass('small')) {
				$jackpotsSwitch[gameNo].addClass('small');
			}

			if (!togglingJackpots[gameNo]) {
				$jackpots[gameNo].find('.pots [data-jackpot-id="' + jackpot.id + '"]')
					.removeClass('active');
				if (Jackpot.jackpots[gameNo].length > 1) {
					togglingJackpots[gameNo] = true;
					jackpotToggle(gameNo);
					return;
				}
				$jackpots[gameNo]
					.find('.pots [data-jackpot-id="' + jackpot.id + '"]')
					.addClass('active');
			}
		}

		function jackpotUpdate(jackpot, update) {
			var gameNo = jackpot.gameNo,
				$jackpot = $jackpots[gameNo].find('[data-jackpot-id=' + jackpot.id + ']'),
				typeChanged = jackpot.data.type !== update.type,
				$title,
				$current,
				$pending,
				oldCurrentAmount,
				oldPendingAmount;

			if (!Object.prototype.hasOwnProperty.call(jackpot.data, 'displayName') ||
				update.displayName !== jackpot.data.displayName) {
				$title = $jackpot.find('.title');
				$title.html(update.displayName);
			}

			if (update.type === 'fixed') {
				$jackpot.removeAttr('data-initialized');
				$jackpot.find('.content .pending').remove();

				if (rollNumber[jackpot.id]) {
					rollNumber[jackpot.id].total.cancel();
					rollNumber[jackpot.id].pending.cancel();
				}

				delete rollNumber[jackpot.id];

				if (typeChanged || !Object.prototype.hasOwnProperty.call(jackpot.data, 'fixedDropAmount') ||
					update.fixedDropAmount !== jackpot.data.fixedDropAmount) {
					$jackpot.find('.content .current .number').html(formatValue(update.fixedDropAmount));
				}

				return;
			}

			if (update.type === 'ranged' && !$jackpot.attr('data-initialized')) {
				rollNumber[jackpot.id] = { total: roller(formatValue), pending: roller(formatValue) };

				$jackpot.find('.content').append(`
					<div class="pending">
						<div class="text">${T.translate('translate_jackpend')}</div>
						<div class="number"><span class="amount"></span></div>
					</div>
				`);

				$jackpot.attr('data-initialized', true);
			}

			if (!rollNumber[jackpot.id]) {
				console.error('Jackpot not initialized properly');
				return;
			}

			if (typeChanged || !Object.prototype.hasOwnProperty.call(jackpot.data, 'currentAmount') ||
				update.currentAmount !== jackpot.data.currentAmount) {
				$current = $jackpot.find('.content .current .number');
				oldCurrentAmount = typeChanged ? 0 : (jackpot.data.currentAmount || 0);
				rollNumber[jackpot.id].total.addToQueue($current, oldCurrentAmount,
					update.currentAmount, settings.games[0].soundStatus ? util.sounds.safe[1] : undefined);
			}

			if (typeChanged || !Object.prototype.hasOwnProperty.call(jackpot.data, 'pendingAmount') ||
				update.pendingAmount !== jackpot.data.pendingAmount) {
				$pending = $jackpot.find('.content .pending .amount');
				oldPendingAmount = typeChanged ? 0 : (jackpot.data.pendingAmount || 0);
				rollNumber[jackpot.id].pending.addToQueue($pending, oldPendingAmount,
					update.pendingAmount, settings.games[0].soundStatus ? util.sounds.safe[2] : undefined);
			}
		}

		function jackpotRemove(jackpot, gameNo) {
			$jackpots[gameNo].find('[data-jackpot-id=' + jackpot.id + ']').remove();
			delete rollNumber[jackpot.id];

			if (Jackpot.jackpots[gameNo].length === 1) {
				togglingJackpots[gameNo] = false;
			}
			if (Jackpot.jackpots[gameNo].length === 0) {
				$jackpotsSwitch[gameNo].removeClass('small');
			}

			if (Jackpot.jackpots[gameNo].length === 0 && settings.games.length === 1) {
				$jackpots[gameNo].addClass('empty');
			}
		}

		function jackpotToggle(gameNo, num) {
			var i = num,
				nextJackpot = i < Jackpot.jackpots[gameNo].length - 1 ? i + 1 : 0,
				oldView;

			if (!togglingJackpots[gameNo]) {
				$jackpots[gameNo]
					.find('.pots [data-jackpot-id="' + Jackpot.jackpots[gameNo][0].id + '"]')
					.removeAttr('style');
				$jackpots[gameNo]
					.find('.pots [data-jackpot-id="' + Jackpot.jackpots[gameNo][0].id + '"]')
					.addClass('active');
				return;
			}

			// if toggle was called and there is already a jackpot toggle further not reset
			if (typeof i === 'undefined') {
				const currentView = $jackpots[0].find('.pots > div:not(.default).active');

				if (currentView.length) {
					i = 0;
					currentView.removeClass('active');
				}
			}

			oldView = $jackpots[gameNo].find('.pots > div:not(.default).active');
			oldView.transition({
				y: '-100%'
			}, 1000, 'ease-out', function () {
				oldView.removeClass('active').css({
					transform: 'translate(0, 100%)'
				});
			});
			$jackpots[gameNo].find('.pots > div:not(.default):eq(' + nextJackpot + ')')
				.addClass('active')
				.css({
					transform: 'translate(0, 100%)'
				})
				.transition({
					y: '0'
				}, 1000, 'ease-out');

			setTimeout(jackpotToggle, settings.local.jackpotDisplay, gameNo, nextJackpot);
		}

		function generateStaticJackpot(pot) {
			return $('<div data-jackpot-id=' + pot.id + ' class="static">' +
				'<div class="title">' + pot.title + '</div>' +
				'<div class="content">' +
				'<div class="current">' +
				'<div class="number">' + pot.prize + '</div>' +
				'</div>' +
				'</div>');
		}

		function jackpotAddStatic(jackpot, gameNo) {
			var pot = generateStaticJackpot(jackpot);

			if ($jackpots[gameNo].hasClass('empty')) {
				$jackpots[gameNo].removeClass('empty');
			}
			$jackpots[gameNo].find('.pots').append(pot);

			staticJackpots.push(pot);

			if (!$jackpotsSwitch[gameNo].hasClass('small')) {
				$jackpotsSwitch[gameNo].addClass('small');
			}

			if (!togglingJackpots[gameNo]) {
				$jackpots[gameNo]
					.find('.pots [data-jackpot-id="' + jackpot.id + '"]')
					.removeClass('active');

				if (staticJackpots.length > 1) {
					togglingJackpots[gameNo] = true;
					jackpotToggleStatic(gameNo);
					return;
				}

				$jackpots[gameNo]
					.find('.pots [data-jackpot-id="' + jackpot.id + '"]')
					.addClass('active');
			}
		}

		function jackpotToggleStatic(gameNo, num) {
			var i = num,
				nextJackpot = i < staticJackpots.length - 1 ? i + 1 : 0,
				oldView;

			if (!togglingJackpots[gameNo]) {
				$jackpots[gameNo]
					.find('.pots [data-jackpot-id="' + staticJackpots[0].id + '"]')
					.removeAttr('style');
				$jackpots[gameNo]
					.find('.pots [data-jackpot-id="' + staticJackpots[0].id + '"]')
					.addClass('active');
				return;
			}

			// if toggle was called and there is already a jackpot toggle further not reset
			if (typeof i === 'undefined') {
				if ($jackpots[0].find('.pots > div:not(.default).active').length) {
					i = 0;
				}
			}

			oldView = $jackpots[gameNo].find('.pots > div:not(.default).active');
			oldView.transition({
				y: '-100%'
			}, 1000, 'ease-out', function () {
				oldView.removeClass('active').css({
					transform: 'translate(0, 100%)'
				});
			});
			$jackpots[gameNo].find('.pots > div:not(.default):eq(' + nextJackpot + ')')
				.addClass('active')
				.css({
					transform: 'translate(0, 100%)'
				})
				.transition({
					y: '0'
				}, 1000, 'ease-out');

			setTimeout(jackpotToggleStatic, settings.local.jackpotDisplay, gameNo, nextJackpot);
		}

		function insertEmptyJackpot(target) {
			target.addClass('empty').html($('<div class="pots"></div>'));
		}

		return object;
	}
);

